export default class AllowedEndorsementDateRange {

	public renewalDate: Date | null = null;
	public endDate: Date | null = null;
	public startDate: Date | null = null; 

	public constructor() {

	}
}